import React from "react";
// import style from './form-navigation.module.sass';
import { Header } from "./Header";
import { Divider } from "antd";
import "../../assets/MobileDeviceAssets/devices.min.css";
import { logger } from "../../constant/winston";
class Navigation extends React.Component {
  state = {
    destopView: true,
    mobileView: false,
  };

  setViews = (key: string) => {
    let { destopView, mobileView } = this.state;
    if (key === "destop") {
      if (destopView && !mobileView) {
        logger.debug("desktop view")
      } else {
        this.setState({ destopView: !destopView });
      }
    } else {
      if (mobileView && !destopView) {
        logger.debug("mobile view")
      } else {
        this.setState({ mobileView: !mobileView });
      }
    }
  };

//   render() {
//     let { destopView, mobileView } = this.state;

    //         } else {
    //             this.setState({ mobileView: !mobileView })

    //         }
    //     }

    // }



    render() {
        let { destopView, mobileView } = this.state

        return( <React.Fragment>
            <div className={"row"} style={{ margin: 0, marginTop: "12px", borderBottom: "1px solid #DEE5F4" }}>
                <Header
                    handleshowView={this.setViews}
                />
            </div>
            <div style={{ display: "flex", height: "100%" }}>
                {destopView &&
                    <React.Fragment>
                        <div className={"row"} style={{ flexWrap: 'unset', margin: 0, height: 'calc(100vh - 60px)', width: destopView && mobileView ? "50%" : "100%" }}>
                            <div className={"container-fluid"} style={{ padding: '40px', height: '100%', overflow: 'hidden', background: "#F7FAFD 0% 0% no-repeat padding-box" }}>
                                {/* <div style={{ border: "1px solid #DEE5F4", borderRadius: "4px", overflow: "scroll", height: "70vh" }}> */}
                                    {this.props.children}
                                {/* </div> */}
                            </div>
                        </div>
                    </React.Fragment>
                }
                {mobileView && destopView && <Divider dashed type={"vertical"} style={{ height: "calc(100vh - 60px)" }} />}
               
                {mobileView &&

                    <div style={{ paddingTop: "40px", width: destopView && mobileView ? "50%" : "100%", background: "#F7FAFD 0% 0% no-repeat padding-box" }}>
                        <MobileView >
                            <div className={"row"}  >
                                <div className={"container-fluid"} style={{ paddingTop: '30px', height: "70vh", maxHeight: "750px", minHeight: "700px", paddingLeft: "0px", paddingRight: "0px" }}>
                                    {this.props.children}
                                </div>
                            </div>
                        </MobileView>

                    </div>
                }


        </div>
      </React.Fragment>
    );
  }
}

export default Navigation;

const MobileView = (props: any) => {
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          background: "#F7FAFD 0% 0% no-repeat padding-box",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "367px",
            background: "#F7FAFD 0% 0% no-repeat padding-box",
          }}
        >
          <div
            className="demoWrapper"
            style={{
              background: "#F7FAFD 0% 0% no-repeat padding-box",
              height: "80vh",
              maxHeight: "700px",
              minHeight: "650px",
            }}
          >
            <div
              className="marvel-device iphone-x"
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="notch" style={{ left: "auto", width: "60%" }}>
                  <div className="camera"></div>
                  <div className="speaker"></div>
                </div>
              </div>
              <div className="top-bar"></div>
              <div className="sleep"></div>
              <div className="bottom-bar"></div>
              <div className="volume"></div>
              <div className="overflow">
                <div className="shadow shadow--tr"></div>
                <div className="shadow shadow--tl"></div>
                <div className="shadow shadow--br"></div>
                <div className="shadow shadow--bl"></div>
              </div>
              <div className="inner-shadow"></div>
              <div className="screen">{props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
